import { motion } from "framer-motion"

const products = [
  {
    id: "1",
    name: "Tiong Sofa",
    designer: "By Marnois",
    price: "₹5,90,000",
    image: "/Zig1.png",
    url: "/product-luxury/tiong-sofa-2",
  },
  {
    id: "2",
    name: "Happy Home",
    designer: "By Neytt Home",
    price: "₹56,000",
    image: "/Zig2.png",
    url: "/product-luxury/happy-home",
  },
  {
    id: "3",
    name: "Rocks Bookshelf",
    designer: "By NPAT",
    price: "₹1,42,000",
    image: "/Zig3.png",
    url: "/product-luxury/rocks-bookshelf-cum-table-cum-seating",
  },
]

export default function MagazineLayout() {
  const handleProductClick = (url) => {
    window.location.href = url
  }

  return (
    <section className="mobile-section-padding bg-stone-100 dark:bg-stone-900 py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="mobile-heading-xl text-4xl font-serif font-light dark:text-white">Premium Showcase</h2>
          <p className="text-muted-foreground mt-2">Alternating layout to keep eyes moving and engaged</p>
        </div>

        <div className="space-y-16">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              className={`new-arrivals-mobile flex flex-col items-center gap-8 md:flex-row cursor-pointer hover:scale-[1.02] transition-transform duration-300 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              onClick={() => handleProductClick(product.url)}
            >
              <div className="new-arrivals-image-mobile relative w-full h-80 md:w-1/2">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-cover rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
                />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center text-center md:text-left">
                <h3 className="text-3xl font-serif font-light dark:text-white hover:text-stone-600 dark:hover:text-stone-300 transition-colors duration-300">{product.name}</h3>
                <p className="text-muted-foreground mt-1">{product.designer}</p>
                <p className="text-stone-700 dark:text-stone-200 text-lg font-light mt-2">{product.price}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
} 